import Vue from 'vue'
import filesize from 'filesize'

const getDefaultState = () => ({
  biens: [],
  bienCurrent: null,
  arboNot: [],
  questions: null,
  questionThemes: [],
  documentsDetails: {},
  portefeuilleSettings: null,
  currentPortefeuilleId: null,
  showUnreadOnly: false
})

const state = getDefaultState()

const getters = {

  bien: (state) => (id) => _.find(state.biens, { id }),

  allowQuestions: (state) => state.portefeuilleSettings && state.portefeuilleSettings.allowQuestions,

  allowDownload: (state) => state.portefeuilleSettings && state.portefeuilleSettings.allowDownload,

  filigraneActivated: (state) => state.portefeuilleSettings && state.portefeuilleSettings.filigraneActivated,

  cgaValidated: (state) => state.portefeuilleSettings && state.portefeuilleSettings.cgaValidated,

}

const mutations = {

  LOGOUT (state) {
    Object.assign(state, getDefaultState())
  },

  BIENS (state, payload) {
    state.biens = payload
  },

  BIEN_NOTIFICATIONS (state, payload) {
    const bien = state.biens.find(i => i.id === payload.id)
    if (!bien) return
    bien.notifications = payload.value
  },

  BIEN_CURRENT (state, payload) {
    state.bienCurrent = payload
  },

  PORTEFEUILLE_SETTINGS (state, payload) {
    state.currentPortefeuilleId = +payload
    state.portefeuilleSettings = null
    const bien = state.biens.find(i => i.portefeuille === +payload)
    if (!bien) return
    state.portefeuilleSettings = {
      allowQuestions: bien.allowQuestions,
      allowDownload: bien.allowDownload,
      filigraneActivated: bien.filigraneActivated,
      cgaValidated: bien.cgaValidated
    }
  },

  ARBO_NOT (state, payload) {
    if (state.bienCurrent !== payload.id) return
    state.arboNot = payload.data
  },

  ARBO_NOT_RESET (state) {
    state.arboNot = []
  },

  ARBO_DETAILS (state, payload) {
    var arbo = state.arboNot.find(item => item.level === payload.payload.arboLevel && item.id === payload.payload.arboID)
    if (!arbo) return
    arbo.details = true
    arbo.documents.forEach((item, i) => {
      const ext = payload.data.find(x => x.id === item.id)
      if (ext === undefined) return
      item.extension = ext.extension
      item.version = ext.version
    })
  },

  COLLECTION_DETAILS (state, payload) {
    var arbo = state.arboNot.find(item => item.level === payload.payload.arboLevel && item.id === payload.payload.arboID)
    if (!arbo) return
    var col = arbo.collections.find(item => item.id === payload.payload.collectionID)
    if (!col) return
    col.details = true
    col.documents.forEach((item, i) => {
      const ext = payload.data.find(x => x.id === item.id)
      if (ext === undefined) return
      item.extension = ext.extension
      item.version = ext.version
    })
  },

  QUESTIONS (state, payload) {
    state.questions = payload.data
  },

  QUESTIONS_RESET (state, payload) {
    state.questions = null
  },

  QUESTION_THEMES (state, payload) {
    state.questionThemes = payload
  },

  DOCUMENT_DETAILS (state, payload) {
    Vue.set(state.documentsDetails, payload.id + '-' + payload.version, payload.data)
  },

  SHOW_UNREAD_ONLY_SET (state, payload) {
    state.showUnreadOnly = payload
  }

}

const actions = {

  async getBiens ({ commit, state }, force = false) {
    if (!force && Object.keys(state.biens).length > 0) return

    const data = await Vue.api.get('/inv/biens')
    commit('BIENS', data)

    if (state.currentPortefeuilleId) {
      commit('PORTEFEUILLE_SETTINGS', state.currentPortefeuilleId)
    }
  },

  async getArboNot ({ commit }, id) {
    const data = await Vue.api.get(`/inv/biens/${id}/arbonotnew`)
    commit('ARBO_NOT', {
      id,
      data: _.orderBy(data, ['level'], ['desc']),
    })
  },

  async getArboDetails ({ commit }, payload) {
    const data = await Vue.api.get(`/inv/details/${payload.arboLevel}/${payload.arboID}`)
    commit('ARBO_DETAILS', { data, payload })
  },

  async getCollectionDetails ({ commit }, payload) {
    const data = await Vue.api.get(`/inv/details/${payload.arboLevel}/${payload.arboID}/${payload.collectionID}`)
    commit('COLLECTION_DETAILS', { data, payload })
  },

  async getQuestions ({ commit }, id) {
    const data = await Vue.api.get(`/inv/questions/${id}`)
    commit('QUESTIONS', { id, data })
  },

  async getQuestionThemes ({ commit, state }) {
    if (Object.keys(state.questionThemes).length > 0) return

    const data = await Vue.api.get('/inv/questions/themes')
    commit('QUESTION_THEMES', data)
  },

  async getDocumentDetails ({ commit, state }, { id, version }) {
    if (state.documentsDetails[id + '-' + version] !== undefined) return
    const data = await Vue.api.get(`/inv/documents/${id}/${version}/details`)
    data.size = filesize(data.size)
    commit('DOCUMENT_DETAILS', { id, version, data })
  },

  async setBienNotifications ({ commit }, payload) {
    await Vue.api.post(`/inv/biens/${payload.id}/notifications`, {
      value: payload.value,
    })
    commit('BIEN_NOTIFICATIONS', payload)
  },

  async setShowUnreadOnly ({ commit }, payload) {
    commit('SHOW_UNREAD_ONLY_SET', payload)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
